import { useEffect, useState } from "react";

export const COLOR_CUTOFF_KEY = "moringa-market-color-cutoff";
export const DEFAULT_COLOR_CUTOFF = "2"; // local hour the next day; "close" = turn black at the 4pm ET close
export const COLOR_CUTOFF_OPTIONS = [
    { value: "close", label: "At market close (4pm New York)" },
    { value: "0", label: "Midnight" },
    { value: "1", label: "1:00 am" },
    { value: "2", label: "2:00 am" },
    { value: "3", label: "3:00 am" },
    { value: "4", label: "4:00 am" },
    { value: "6", label: "6:00 am" },
];

const ET = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York", hourCycle: "h23",
    year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", weekday: "short",
});

function etParts(d) {
    const p = Object.fromEntries(ET.formatToParts(d).map((x) => [x.type, x.value]));
    return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour, min: +p.minute, wd: p.weekday };
}

// Date of HH:MM New York time on the ET calendar day `daysAgo` days before `now`
function etTime(now, daysAgo, h, min) {
    const ref = new Date(now.getTime() - daysAgo * 86400000);
    const p = etParts(ref);
    const offset = Date.UTC(p.y, p.m - 1, p.d, p.h, p.min) - Math.floor(ref.getTime() / 60000) * 60000;
    return { at: new Date(Date.UTC(p.y, p.m - 1, p.d, h, min) - offset), weekday: p.wd };
}

/** True while red/green should show: from the 9:30am ET open until the chosen cutoff
 * (4pm close, or a local hour on the following day). Weekends stay black. */
export function marketColorsOn(cutoff = DEFAULT_COLOR_CUTOFF, now = new Date()) {
    for (let back = 0; back < 5; back++) {
        const open = etTime(now, back, 9, 30);
        if (open.weekday === "Sat" || open.weekday === "Sun" || open.at > now) continue;
        let end;
        if (cutoff === "close") end = etTime(now, back, 16, 0).at;
        else {
            end = new Date(open.at);
            end.setDate(end.getDate() + 1);
            end.setHours(Number(cutoff), 0, 0, 0);
        }
        return now <= end;
    }
    return false;
}

export function getColorCutoff() {
    try { return localStorage.getItem(COLOR_CUTOFF_KEY) || DEFAULT_COLOR_CUTOFF; } catch { return DEFAULT_COLOR_CUTOFF; }
}

export function useMarketColors() {
    const [on, setOn] = useState(() => marketColorsOn(getColorCutoff()));
    useEffect(() => {
        const tick = () => setOn(marketColorsOn(getColorCutoff()));
        const id = setInterval(tick, 60000);
        window.addEventListener("storage", tick);
        window.addEventListener("market-color-cutoff", tick);
        return () => { clearInterval(id); window.removeEventListener("storage", tick); window.removeEventListener("market-color-cutoff", tick); };
    }, []);
    return on;
}
